export function deepMergeMissing<T, U>(left: T, right: U): T & U {
  if (typeof left !== 'object' || left === null) return left as T & U
  if (typeof right !== 'object' || right === null) return left as T & U

  for (const key in right) {
    if (Object.prototype.hasOwnProperty.call(right, key)) {
      const leftValue = (left as any)[key]
      const rightValue = (right as any)[key]

      if (leftValue === undefined) {
        ;(left as any)[key] = rightValue
      } else if (typeof leftValue === 'object' && typeof rightValue === 'object') {
        deepMergeMissing(leftValue, rightValue)
      }
    }
  }
  return left as T & U
}
